export default {
  // HR
  HR_NEW_BUTTON_CLICK: 'hr-onboarding-new-button:click',
  HR_ONBOARDING_MAINTENANCE: 'onboarding-maintenance:show',
  HR_FORM_SHOW_EXISTING_EMPLOYEE: 'hr:onboarding-form:show-existing',
  HR_FORM_SHOW: 'hr:onboarding-form:show',
  HR_FORM_FROM_HIRE: 'hr:onboarding-form:show-from-hire',
  HR_FORM_CLOSE: 'hr:onboarding-form:close',
  HR_TAB_VIEW_SHOW: 'hr:onboarding-tab:show',
  HR_TAB_EDIT_SHOW: 'hr:onboarding-tab-edit:show',
  HR_UPDATE_ONBOARDING: 'hr:onboarding-form:update',
  HR_RESET_ONBOARDING: 'hr:onboarding-form:reset',
  HR_ADDON: 'hr:addon:show',
  HR_ADDON_LOADED: 'hr:addon:loaded',
  HR_ADDON_SUCCESS: 'hr:addon:success',

  // PEOPLE
  PEOPLE_PROFILE_SHOW: 'people:profile:show',
  PEOPLE_PROFILE_CLOSE: 'people:profile:close',
  PEOPLE_PROFILE_CLOSE_VUE_ROUTER: 'people:profile:close-vue-router',
  PEOPLE_PROFILE_DIALOG_CLOSED: 'people:profile:dialog-closed',
  PEOPLE_PROFILE_TAB_EDIT_OPEN: 'people:profile:tab-edit-open',
  PEOPLE_PROFILE_TAB_CLOSE_REQUESTED: 'people:profile:tab-close-requested',
  PEOPLE_MODULE_SHOW: 'people:module:show',
  PEOPLE_PROFILE_AFTER_CLOSE: 'people:profile:after-close',
  PEOPLE_MODULE_CLOSE: 'people:module:close',
  PEOPLE_MODULE_REFRESH: 'people:module:refresh',
  PEOPLE_ROLES_REFRESH: 'people:roles:refresh',
  PEOPLE_EMPLOYMENT_FORM_SAVED: 'people:employment-details:saved',
  PEOPLE_EMPLOYMENT_END_MODAL_SHOW: 'people:employment-end-modal:show',
  PEOPLE_FORM_ADD_CLOSE: 'people:form-add:close',
  PEOPLE_FORM_ADD_SHOW: 'people:form-add:show',
  PEOPLE_FILTER_CHANGE: 'people:filter:change',
  PEOPLE_BULK_CLOSE: 'people:bulk:close',
  PEOPLE_BULK_PAY_RATES_FINISHED: 'people:bulk:pay-rates:finished',
  PEOPLE_BULK_STRESS_PROFILES_FINISHED: 'people:bulk:stress-profiles:finished',
  PEOPLE_BULK_ARCHIVE_FINISHED: 'people:bulk:archive:finished',
  PEOPLE_BULK_DELETE_FINISHED: 'people:bulk:delete:finished',
  PEOPLE_SHIFTS_SHIFT_REPLACE: 'people:shifts:shift-replace',
  VALIDATE_AGREED_TOTAL_HOURS_WORK_PERIOD:
    'validate-agreed-total-hours-work-period',
  WORK_PERIOD_NOT_SELECTED_ERROR: 'show-work-period-not-selected-error',
  VALIDATE_AGREED_HOUR_DETAILS: 'validate-agreed-hours-details',
  // INVITE
  INVITE_MODULE: 'invite:module',
  MULTI_SELECTION_REMOVE_REQUESTED: 'multi-selector-remove-requested',
  MIGRATE_EMPLOYEES_OUTDATED_CONTRACTS: 'migrate-employees-outdated-contracts',

  LAUNCH_SLEEP_OVER_AREAS: 'sleepover-areas:open',

  // SCHEDULE
  SCHEDULE_EMPLOYEES_REFRESH: 'schedule-roster:employees:added',

  // LEAVE
  LEAVE_REQUEST_FORM_SAVE: 'leave-request-form:save',
  LEAVE_REQUEST_FORM_INIT: 'leave-request-form:init',
  LEAVE_REQUEST_FORM_ADD: 'leave-request-form:add',
  LEAVE_REQUEST_SAVE_SUCCESS: 'leave-request-form:save-success',
  LEAVE_HR_ADDON: 'leave:hr:addon:show',
  LEAVE_APP_HR_ADDON: 'leave:app:hr:addon:show',
  PEOPLE_SELECT_LEAVE_ENTITLEMENTS_DIALOG_CLOSED:
    'select-leave-entitlements-dialog:closed',
  PEOPLE_EMPLOYMENT_FORM_PAY_RATE_CHANGED:
    'people:employment-details:pay-rate-changed',
  PEOPLE_SELECT_LEAVE_ENTITLEMENTS_DIALOG_SAVED:
    'select-leave-entitlements-dialog:saved',
  LEAVE_REQUEST_VALIDATION_DIALOG_CLOSE:
    'leave-request-validation-dialog:close',
  SET_UP_PAY_RATES_MODAL_SHOW: 'people:single-pay-rates-modal:show',
  SET_UP_PAY_RATES_MODAL_HIDE: 'people:single-pay-rates-modal:hide',
  ASSIGN_PAY_CALENDAR_MODAL_SHOW: 'people:assign-pay-calendar-modal:show',
  ASSIGN_PAY_CALENDAR_MODAL_HIDE: 'people:assign-pay-calendar-modal:hide',

  // XERO ONBOARDING EVENTS
  XERO_ONBOARDING_PAY_RATE_SET_PERFORMED: 'onboarding:payrate:set:performed',
  XERO_ONBOARDING_EMPLOYEES_INVITE_PERFORMED:
    'onboarding:employees:invite:performed',

  // SETTINGS
  SETTINGS_BUSINESS_DOCUMENT_REQUEST_OPEN:
    'settings-business-document-request:open',
  TEAM_PERFORMANCE_SETTINGS_CHANGED:
    'team-performance-settings:changed',
};
